// Views
import Login from '../views/Login.vue';
import Home from '../views/Home.vue';

// Components
import MessageForm from '../components/Contents/Message/MessageForm.vue';
import Dashboard from '../components/Contents/Dashboard/DashboardView.vue';
import SchedulingMessage from '../components/Contents/ScheduleMessage/SchedulingMessage.vue';
import SchedulingWeb from '../components/Contents/ScheduleWeb/SchedulingWeb.vue';
import ShippingList from '../components/Contents/ScheduleWeb/ShippingList.vue';
import PushWeb from '../components/Contents/SendNotification/PushWeb.vue';
import UrlTools from '../components/Contents/UrlTools/UrlTools.vue';
import SplitTest from '../components/Contents/SplitTest/SplitTest.vue';
// import AutomaticTriggers from '../components/Contents/AutomaticsTriggers/AutomaticTriggersView.vue';
import Facebook from '../components/Contents/Facebook/Facebook.vue';

// Chilren schedule-web
import DuplicateForm from '../components/Contents/ScheduleWeb/DuplicateForm.vue';
import DuplicatePushWeb from '../components/Contents/ScheduleMessage/DuplicatePushWeb.vue';

export default [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/envio-mensagem',
        name: 'MessageForm',
        component: MessageForm,
        meta: {
          requiresAuth: true,
          roles: ['ANALYST', 'ADMIN', 'ROOT'],
        },
      },
      {
        path: '/agendamentos',
        name: 'SchedulingMessage',
        component: SchedulingMessage,
        meta: {
          requiresAuth: true,
          roles: ['ANALYST', 'ADMIN', 'ROOT'],
        },
      },
      {
        path: '/lista-de-envios',
        name: 'ShippingList',
        component: ShippingList,
        meta: {
          requiresAuth: true,
          roles: ['ANALYST', 'ADMIN', 'ROOT'],
        },
      },
      {
        path: '/scheduling-web',
        name: 'SchedulingWeb',
        component: SchedulingWeb,
        meta: {
          requiresAuth: true,
          roles: ['ANALYST', 'ADMIN', 'ROOT'],
        },
      },
      {
        path: '/duplicate',
        name: 'DuplicateForm',
        component: DuplicateForm,
        meta: {
          requiresAuth: true,
          roles: ['ANALYST', 'ADMIN', 'ROOT'],
        },
      },
      {
        path: '/enviar-notificacao',
        name: 'PushWeb',
        component: PushWeb,
        meta: {
          requiresAuth: true,
          roles: [
            'WEB_PUSH_NOTIFICATION_APP',
            'ADMIN',
            'ROOT',
            'WEB_PUSH_NOTIFICATION_API',
          ],
        },
      },
      {
        path: '/duplicate-push-web',
        name: 'DuplicatePushWeb',
        component: DuplicatePushWeb,
        meta: {
          requiresAuth: true,
          roles: ['ANALYST', 'ADMIN', 'ROOT'],
        },
      },
      {
        path: '/ferraments-url',
        name: 'UrlTools',
        component: UrlTools,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/teste-ab',
        name: 'SplitTest',
        component: SplitTest,
        meta: {
          requiresAuth: true,
        },
      },
      // {
      //   path: '/disparos-automaticos',
      //   name: 'AutomaticTriggers',
      //   component: AutomaticTriggers,
      //   meta: {
      //     requiresAuth: true,
      //     roles: ["EMAIL_COMUNICATION_API", "ADMIN", "ROOT"],
      //   },
      // },
      {
        path: '/facebook',
        name: 'Facebook',
        component: Facebook,
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '*',
    component: Login,
  },
];



// WEBPACK FOOTER //
// ./src/router/routes.js